import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'arrow-roundabout-left',
  'IconArrowRoundaboutLeft',
  [
    ['path', { d: 'M3 9h8a5 5 0 1 1 5 5v7', key: 'svg-0' }],
    ['path', { d: 'M7 5l-4 4l4 4', key: 'svg-1' }],
  ],
);
